'use strict';

(function () {
  'use strict';

  angular.module('referrals').component('referralDone', {
    bindings: {
      user: '<',
      returnUrl: '<',
      showListLink: '<',
      showListFn: '<',
      goBackFn: '<'
    },
    templateUrl: 'referrals/templates/nextSteps.html',
    controller: ReferralDoneCtrl
  });

  ReferralDoneCtrl.$inject = ['$log', '$state', 'domainSvc', 'msAuth'];

  function ReferralDoneCtrl($log, $state, domainSvc, msAuth) {
    var vm = this;
    vm.showProviderConnect = false;

    vm.$onInit = function () {
      _activate();
    };

    function _activate() {
      //build the always needed vm properties
      vm.adminDomain = domainSvc.getAdminDomain();
      vm.baseDomain = domainSvc.getBaseDomain();
      vm.returnUrl = vm.returnUrl || '/login';
      if (vm.user) {
        vm.showProviderConnect = msAuth.hasPermission('ADMIN') || vm.user.accessCode.type === 'INTERNAL';
      }
    }
  }
})();